import { ImgWebConfig } from '../types';

export const imgWebConfig: ImgWebConfig = {
  brand: 'letsbetmd',
  hostUrlDev: 'https://image-assets-server-dot-cms-headless-gae.ew.r.appspot.com/',
  hostUrlProd: 'https://letsbetmd.com/'
};
